import { getPlatform } from "@cems-eco/core/src/utils/platform";
import { defineModuleProvider } from "@cems-eco/core/src/utils/module";

export default defineModuleProvider({
    name: "auth",
    routes: [
        {
            path: '/',
            redirect: '/auth/login',
        },
        {
            path: '/auth/login',
            name: 'Login',
            meta: { layout: "login" },
            component: () => import(/* webpackChunkName: "auth.login" */ `./pages/login/login.${getPlatform()}.vue`),
        },
        {
            path: '/auth/site',
            name: 'Site Login',
            meta: { layout: "blank" },
            component: () => import(/* webpackChunkName: "auth.site" */ `./pages/site/site.vue`),
        },
        {
            path: '/auth/sso/:platform',
            name: 'SSO',
            meta: { layout: "blank" },
            component: () => import(/* webpackChunkName: "auth.sso" */ `./pages/sso/sso.vue`),
        },

    ],
    menu: [],
    install: () => {

    }
});